import { POKER_EVENT_OVERRIDES } from './poker';
import type { ProductEventFieldConfig } from './types';

export const PRODUCT_EVENT_FIELDS: ProductEventFieldConfig = {
    poker: POKER_EVENT_OVERRIDES
};
